import { render, staticRenderFns } from "./SendPasswordLink.vue?vue&type=template&id=fc40947e&scoped=true&"
var script = {}
import style0 from "./SendPasswordLink.vue?vue&type=style&index=0&id=fc40947e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc40947e",
  null
  
)

export default component.exports